import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { DeviceMobileIcon } from '@arcade/web/icons/react'
import { Flex, spacing, Text } from '@cash-design-system/react'
import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { FormBlockerElementRemoteImageElementHorizontalAlignment } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'
import { DownloadButton } from '@cash-web/shared-feature-common'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { isMobileDevice } from '@cash-web/shared-util-user-agent'

import { useDownloadCashAppUrl } from '../../util/useDownloadCashAppUrl'
import RemoteImageElement from '../FormBlocker/elements/RemoteImageElement/RemoteImageElement'

export const BlockerRedirectToMobile = () => {
  const { t } = useTranslation()
  const flow = useFlowContext()
  const imageUrl = useDownloadCashAppUrl()
  const isMobileLayout = isMobileDevice()

  const content =
    flow.active?.clientScenario === ClientScenario.ONBOARDING
      ? t('To continue creating an account, download Cash App on your mobile device.', {
          context: 'Continue in the app text',
        })
      : t("To proceed, you'll need to download Cash App on your mobile device. Open the mobile app and try again.", {
          context: 'Continue in the app text',
        })

  useEffect(() => {
    logger.addBreadcrumb('BlockerRedirectToMobile in ' + flow.active?.clientScenario)
  }, [flow.active?.clientScenario])

  return (
    <Flex gap={spacing.xxl} flexDirection="column">
      <Flex gap={spacing.m} flexDirection="column">
        <DeviceMobileIcon size={32} />
        <Text typography="numeralSmall" as="h2" color="textStandard">
          {t('Continue in the app', { context: 'header' })}
        </Text>
        <Text typography="body">{content}</Text>
        {isMobileLayout ? (
          <DownloadButton pageName="blocker-redirect-to-mobile" />
        ) : (
          <RemoteImageElement
            alignment={FormBlockerElementRemoteImageElementHorizontalAlignment.CENTER}
            image={{
              dark_url: imageUrl,
              light_url: imageUrl,
            }}
            width={200}
            height={200}
          />
        )}
      </Flex>
    </Flex>
  )
}
